import React, { useState } from 'react';
import { Helmet } from "react-helmet";
import Navbar from "components/Navbar";
import { Heading, Input, Button } from "../../components";
import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL || "http://localhost:5050/api"; // Default fallback for development

const ForgotPassword = () => {
    const [email, setEmail] = useState('');
    const [message, setMessage] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
            const response = await axios.post(`${apiUrl}/forget_password`, { email });
            setMessage(response.data.message);
            setError('');
        } catch (err) {
            setMessage('');
            setError(err.response?.data?.message || 'Error sending reset link.');
        }
    };

    return (
        <>
            <Helmet>
                <title>Forgot Password - Request Reset Link</title>
                <meta
                    name="description"
                    content="Forgot your password? Enter your email to receive a reset link and regain access to your account."
                />
            </Helmet>

            <div className="w-full flex flex-col bg-gray-900_01">
                <Navbar />
                <div className="flex flex-col items-center min-h-screen bg-gray-900_01 mt-60">
                    <div className="w-[420px] h-auto p-4 flex flex-col gap-[10px] items-center text-white-a700">
                        <Heading className="h-12">Forget Password</Heading>
                        <p className="text-[16px] text-center ">
                            Enter your email to receive a reset link.
                        </p>
                        <form
                            className="flex flex-col gap-3 self-stretch"
                            onSubmit={handleSubmit}
                        >
                            <Input
                                value={email}
                                type="email"
                                onChange={(e) => setEmail(e.target.value)}
                                required
                                shape="square"
                                name="Email Field"
                                placeholder="Enter your email"
                                className="bg-gray-900 text-white_a700"
                                style={{
                                    backgroundColor: "var(--gray_900)",
                                    borderColor: "var(--gray_900_02)",
                                    color: "var(--white_a700)",
                                    margin: '0',
                                }}
                            />
                            {error && <p style={{ color: 'red' }}>{error}</p>}
                            {message && <p style={{ color: 'green' }}>{message}</p>}
                            <Button
                                type="submit"
                                shape="square"
                                color="indigo_A700"
                                className="px-[34px] sm:px-5"
                            >
                                Send Reset Link
                            </Button>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ForgotPassword;
